export const Wordmark = ({ inverted = false, size = "md" }) => {
  const text = size === "lg" ? "text-4xl" : size === "sm" ? "text-lg" : "text-2xl";
  return (
    <div data-testid="brand-wordmark" className="flex items-center gap-2 select-none">
      <div className={`flex flex-col leading-none ${inverted ? "text-white" : "text-slate-900"}`}>
        <span className={`font-heading font-black uppercase tracking-tighter ${text}`}>
          EF <span className={inverted ? "text-emerald-400" : "text-emerald-600"}>INFRA</span>
        </span>
        <span className={`mt-1 h-[3px] w-full ${inverted ? "bg-emerald-400" : "bg-emerald-600"}`} />
      </div>
    </div>
  );
};
